import { render, staticRenderFns } from "./wantList.vue?vue&type=template&id=825986dc&scoped=true&"
import script from "./wantList.vue?vue&type=script&lang=ts&"
export * from "./wantList.vue?vue&type=script&lang=ts&"
import style0 from "./wantList.vue?vue&type=style&index=0&id=825986dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "825986dc",
  null
  
)

export default component.exports